import axiosInstance from '../auth/AuthUserService.js'

export default class ComissoesService {

  getAll() {
    const url = '/comissoes/listar';
    return axiosInstance.get(url);
  }
}